<template>
    <div>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            Class Course
                        </th>
                        <th class="text-center">
                            Once / Permanent
                        </th>
                        <th class="text-left">
                            From
                        </th>
                        <th class="text-left">
                            To
                        </th>
                        <th class="text-left">
                            Reason
                        </th>
                        <th>
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="request in requests" :key="request.id">
                        <td class="py-3">
                            <div class="d-flex align-center">
                                <router-link class="me-3" :to="{name: 'course', params: {id: request.enrollment.course.id}}">
                                    <v-avatar tile width="60" height="50" style="border-radius: 5px!important" v-ripple="{class: 'black--text'}">
                                        <v-img :src="request.enrollment.course.image_url" />
                                    </v-avatar>
                                </router-link>
                                <div>
                                    <div class="strong-text--text nowrap mb-1 font-weight-medium">{{request.enrollment.course.name}}</div>
                                    <div>
                                        <v-chip class="font-weight-medium" text small label>
                                            Last suggestion by: {{lastProposerName(request)}}
                                        </v-chip>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="text-center">
                            <v-chip v-if="request.permanent" color="primary">
                                <v-icon size="20" left class="me-1">mdi-repeat</v-icon>
                                Permanent
                            </v-chip>
                            <v-chip v-else>
                                <v-icon size="20" left class="me-1">mdi-numeric-1-circle-outline</v-icon>
                                Once
                            </v-chip>
                        </td>
                        <td>
                            <v-chip text class="font-weight-medium">
                                <v-icon left>mdi-clock-outline</v-icon>
                                <span>{{request.old_start_formated}}</span>
                            </v-chip>
                        </td>
                        <td>
                            <v-chip color="teal" text class="teal lighten-5 teal--text text--darken-2 font-weight-bold">
                                <v-icon left>mdi-clock-outline</v-icon>
                                <span>{{request.start_formated}}</span>
                            </v-chip>
                        </td>
                        <td>
                            <v-btn v-if="request.reason" @click="openReasonDialog(request)">
                                <v-icon left>mdi-text</v-icon>
                                <span style="text-transform: none">Show Reason</span>
                            </v-btn>
                            <span v-else>No Reason</span>
                        </td>
                        <td style="white-space: nowrap;">
                            <v-btn color="teal" dark class="me-2" @click="showApproveDialog(request)">
                                Approve
                            </v-btn>
                            <v-btn color="indigo" dark class="me-2" @click="showSuggestDialog(request)">
                                <v-icon left size="18">mdi-clock-edit-outline</v-icon>
                                Suggest Another Time
                            </v-btn>
                            <v-btn color="red" dark @click="showRejectDialog(request)">
                                Reject
                            </v-btn>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <v-dialog v-model="reasonDialog" max-width="350">
            <v-card>
                <v-card-title>
                    <v-icon class="me-2">mdi-text</v-icon>
                    <span>Reason</span>
                </v-card-title>
                <v-card-text class="text--text">
                    <div v-if="reasonItem && reasonItem.reason" style="white-space: pre-line;">{{reasonItem.reason}}</div>
                </v-card-text>
                <v-btn absolute top right icon color="muted" @click="reasonDialog = false;">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card>
        </v-dialog>

        <v-dialog v-model="approveDialog" max-width="350">
            <v-card>
                <v-card-title>Confirm Reschedule</v-card-title>
                <v-card-text>
                    Are you sure that you want to approve this request? The calendar will be updated immediately.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="approving" @click="approveDialog = false">Cancel</v-btn>
                    <v-btn :loading="approving" :disabled="approving" text color="success" @click="approveRequest(approveRequestId)">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="rejectDialog" max-width="350">
            <v-card>
                <v-card-title>Confirm Rejection</v-card-title>
                <v-card-text>
                    Are you sure that you want to reject this request?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="rejecting" @click="rejectDialog = false">Cancel</v-btn>
                    <v-btn :loading="rejecting" :disabled="rejecting" text color="red" @click="rejectRequest(rejectRequestId)">Reject</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Suggest Another Time Dialog -->
        <v-dialog v-model="suggestDialog" max-width="400">
            <v-card>
                <v-card-title>
                    <v-icon color="indigo" class="me-2">mdi-clock-edit-outline</v-icon>
                    Suggest Another Time
                </v-card-title>
                <v-card-text>
                    <v-menu ref="suggestMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field hide-details placeholder="New Day" v-model="suggestForm.date" label="Day" prepend-inner-icon="mdi-calendar" class="mb-5" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="suggestForm.date" :min="today" @change="saveSuggestMenu" color="primary"></v-date-picker>
                    </v-menu>
                    <time-input v-model="suggestForm.start_time" :outlined="false" label="New Start Time" placeholder="Start Time" class="mb-5" />
                    <v-checkbox v-model="suggestForm.permanent" label="Permanent Reschedule" hide-details class="mb-5" />
                    <v-textarea v-model="suggestForm.reason" label="Reason" placeholder="Why this time?" outlined rows="3" hide-details />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="muted" :disabled="suggesting" @click="suggestDialog = false">Cancel</v-btn>
                    <v-btn text color="indigo" :disabled="suggesting || !suggestForm.date || !suggestForm.start_time || !suggestForm.reason" :loading="suggesting" @click="submitSuggestion()">Send Suggestion</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import TimeInput from '@/components/custom/time-input'

export default {
    props: {
        requests: Array
    },
    components: {
        TimeInput
    },
    data(){
        let d = new Date();
        return {
            today: d.toISOString().substr(0, 10),

            approving: false,
            approveRequestId: null,
            approveDialog: false,

            rejecting: false,
            rejectRequestId: null,
            rejectDialog: false,

            suggesting: false,
            suggestDialog: false,
            suggestRequestId: null,
            suggestForm: {
                date: '',
                start_time: '',
                permanent: false,
                reason: '',
            },

            reasonDialog: false,
            reasonItem: null,
        }
    },
    computed: {
        ...GlobalComputed,

    },
    methods: {
        ...GlobalMethods,

        lastProposerName(request){
            const proposerId = request.last_proposer_id || (request.sender && request.sender.id);
            if (request.sender && request.sender.id === proposerId) return request.sender.name;
            if (request.receiver && request.receiver.id === proposerId) return request.receiver.name;
            return request.sender ? request.sender.name : '';
        },
        showApproveDialog(request){
            this.approveRequestId = request.id;
            this.approveDialog = true;
        },
        showRejectDialog(request){
            this.rejectRequestId = request.id;
            this.rejectDialog = true;
        },
        showSuggestDialog(request){
            this.suggestRequestId = request.id;
            const startDate = new Date(request.start);
            this.suggestForm.date = startDate.toISOString().substr(0, 10);
            const hours = String(startDate.getHours()).padStart(2, '0');
            const minutes = String(startDate.getMinutes()).padStart(2, '0');
            this.suggestForm.start_time = `${hours}:${minutes}`;
            this.suggestForm.permanent = request.permanent;
            this.suggestForm.reason = '';
            this.suggestDialog = true;
        },
        saveSuggestMenu(date){
            this.$refs.suggestMenu.save(date);
        },
        openReasonDialog(request){
            this.reasonItem = request;
            this.reasonDialog = true;
        },
        approveRequest(id){
            if (!this.approving){
                this.approving = true;
                return this.$store.dispatch('rescheduleRequestAction', {action: 'approve', id: this.approveRequestId}).then(response=>{
                    this.approving = false;
                    this.showMsg('Reschedule has been approved successfully', 'success');
                    this.$router.push({name: 'calendar'});
                }).catch(error=>{
                    this.approving = false;
                    this.showMsg('Error occurred during preforming your action', 'error');
                })
            }
        },
        rejectRequest(id){
            if (!this.rejecting){
                this.rejecting = true;
                return this.$store.dispatch('rescheduleRequestAction', {action: 'reject', id: this.rejectRequestId}).then(response=>{
                    this.rejecting = false;
                    this.showMsg('Reschedule request rejected successfully', 'success');
                    this.$router.push({name: 'calendar'});
                }).catch(error=>{
                    this.rejecting = false;
                    this.showMsg('Error occurred during preforming your action', 'error');
                })
            }
        },
        submitSuggestion(){
            if (!this.suggesting){
                this.suggesting = true;
                return this.$store.dispatch('suggestRescheduleTime', {
                    id: this.suggestRequestId,
                    date: this.suggestForm.date,
                    time: this.suggestForm.start_time,
                    permanent: this.suggestForm.permanent,
                    reason: this.suggestForm.reason,
                }).then(response=>{
                    this.suggesting = false;
                    this.suggestDialog = false;
                    this.showMsg('New time suggested. The other side has been notified.', 'success');
                    this.$emit('load');
                }).catch(error=>{
                    this.suggesting = false;
                    const msg = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Error occurred during performing your action';
                    this.showMsg(msg, 'error');
                })
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
